export default [{
  icon: 'multiline_chart',
  name: 'dashboard',
  items: [],
},
{
  icon: 'receipt',
  name: 'called-list',
  items: [],
},
{
  icon: 'event',
  name: 'event-list',
  items: [],
},
{
  icon: 'sync_alt',
  name: 'user-project-list',
  items: [],
},
{
  icon: 'assignment',
  name: 'reports',
  items: [
    {
      icon: 'date_range',
      name: 'cycle-consolidated',
    },
  ],
},
{
  icon: 'line_axis',
  name: 'zoho-reports',
  path: '#',
  requireRoles: ['master'],
  items: [
    {
      icon: 'analytics',
      name: 'zoho-report-view',
      requireRoles: ['master'],
    },
    {
      icon: 'post_add',
      name: 'zoho-report-group-list',
      requireRoles: ['master'],
    },
    {
      icon: 'lock',
      name: 'zoho-report-credential-list',
      requireRoles: ['master'],
    },
  ],
},
{
  icon: 'settings_applications',
  name: 'admin',
  path: '#',
  requireRoles: ['master', 'admin', 'admin_cliente'],
  items: [
    {
      icon: 'request_page',
      name: 'billing-report-list',
      requireRoles: ['master', 'admin'],
    },
    {
      icon: 'work',
      name: 'project-list',
      requireRoles: ['master', 'admin'],
    },
    {
      icon: 'date_range',
      name: 'cycle-list',
      requireRoles: ['master', 'admin'],
    },
    {
      icon: 'assignment_ind',
      name: 'client-list',
      requireRoles: ['master', 'admin'],
    },
    {
      icon: 'save',
      name: 'table-manager-list',
      requireRoles: ['master', 'admin'],
    },
    {
      icon: 'update',
      name: 'load-conf-list',
      requireRoles: ['master', 'admin', 'admin_cliente'],
    },
    {
      icon: 'people',
      name: 'user-list',
      requireRoles: ['master', 'admin', 'admin_cliente'],
    },
    {
      icon: 'settings',
      name: 'settings-list',
      requireRoles: ['master', 'admin'],
    },
  ],
}];



// WEBPACK FOOTER //
// ./src/components/layout/MenuItems.js